'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'text': 'tcl__Input-b9c57394',
  'isInvalid': 'tcl__Input-0eb86cf4',
  'checkbox': 'tcl__Input-42838846',
  'radio': 'tcl__Input-0784f0e7',
  'wrapper': 'tcl__Input-67b59825',
  'prefix': 'tcl__Input-18e88275',
  'hasPrefix': 'tcl__Input-a1a84bff'
};


function isSet(prop) {
  return typeof prop !== 'undefined' && prop !== null;
}

/**
 * Core Input component.
 */

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
      // checked='indeterminate' controlled state
      if (_this.props.checked === 'indeterminate') {
        e.target.indeterminate = true;
      }
      _this.props.onClick(e);
    }, _this.setIndeterminate = function () {
      // set the indeterminate state since react does not support it as a native prop
      var _this$props = _this.props,
          type = _this$props.type,
          checked = _this$props.checked,
          defaultChecked = _this$props.defaultChecked;

      if (type !== 'checkbox') return;
      _this.input.indeterminate = checked === 'indeterminate' || defaultChecked === 'indeterminate';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Input, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setIndeterminate();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.setIndeterminate();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classNames;

      var _props = this.props,
          type = _props.type,
          className = _props.className,
          inputRef = _props.inputRef,
          isValid = _props.isValid,
          checked = _props.checked,
          defaultChecked = _props.defaultChecked,
          prefix = _props.prefix,
          prefixIcon = _props.prefixIcon,
          props = _objectWithoutProperties(_props, ['type', 'className', 'inputRef', 'isValid', 'checked', 'defaultChecked', 'prefix', 'prefixIcon']);

      var hasPrefix = Boolean(prefix) || Boolean(prefixIcon);
      var inputClass = styles[['checkbox', 'radio'].includes(type) ? type : 'text'];

      var extraProps = {};
      if (isSet(checked)) extraProps.checked = checked === true;
      if (isSet(defaultChecked)) extraProps.defaultChecked = defaultChecked === true;

      var input = _react2.default.createElement('input', _extends({
        ref: function ref(el) {
          _this2.input = el;
          inputRef(el);
        },
        type: type,
        className: (0, _classnames2.default)(className, inputClass, (_classNames = {}, _defineProperty(_classNames, styles.isInvalid, !isValid), _defineProperty(_classNames, styles.hasPrefix, hasPrefix), _classNames))
      }, props, {
        onClick: this.onClick
      }, extraProps));

      return hasPrefix ? _react2.default.createElement(
        'div',
        { className: styles.wrapper },
        hasPrefix && _react2.default.createElement(
          'span',
          { className: styles.prefix },
          prefix || _react2.default.createElement(_Icon2.default, { name: prefixIcon, size: 18 })
        ),
        input
      ) : input;
    }
  }]);

  return Input;
}(_react.Component);

Input.displayName = 'Input';


Input.propTypes = _extends({}, _withSpacing.propTypes, {

  /**
   * Any additional css classes.
   */
  className: _propTypes2.default.string,

  /**
   * Indicates that the input's content is not valid.
   */
  isValid: _propTypes2.default.bool,

  /**
   * Controlled value for checkbox. The "indeterminate" value represents a state when related
   * items are not all checked (e.g. nested checkboxes or select all items in page).
   */
  checked: _propTypes2.default.oneOf([true, false, 'indeterminate']),

  /**
   * Uncontrolled value for checkbox.
   */
  defaultChecked: _propTypes2.default.oneOf([true, false, 'indeterminate']),

  /**
   * Function called when input is clicked.
   */
  onClick: _propTypes2.default.func,

  /**
   * Type of input. Can be any of the available HTML types.
   */
  type: _propTypes2.default.oneOf(['button', 'checkbox', 'color', 'date', 'datetime-local', 'email', 'file', 'hidden', 'image', 'month', 'number', 'password', 'radio', 'range', 'reset', 'search', 'submit', 'tel', 'text', 'time', 'url', 'week']),

  /**
   * Function called with reference to native <input> element.
   */
  inputRef: _propTypes2.default.func,

  /**
   * Letter prefix, displayed in a box before the editable content.
   */
  prefix: _propTypes2.default.string,

  /**
   * Icon prefix, displayed in a box before the editable content.
   */
  prefixIcon: _propTypes2.default.string
});

Input.defaultProps = {
  type: 'text',
  isValid: true,
  onClick: _noop2.default,
  inputRef: _noop2.default,
  className: '',
  checked: undefined,
  defaultChecked: undefined,
  prefix: undefined,
  prefixIcon: undefined
};

exports.default = (0, _withSpacing2.default)(Input);